module.exports = __webpack_public_path__ + "static/media/32-1.5f6ba4b4.mp3";